
// ADMIN LOGIN COMPONENT
// Save as src/adminwork/Login.js

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

const Login = () => {
  // Navigation hook
  const navigate = useNavigate();
  
  // Form state
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  
  // Error message state
  const [error, setError] = useState('');
  
  // Check if already logged in
  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin');
    if (isAdmin === 'true') {
      navigate('/admindashboard'); // Using your existing route
    }
  }, [navigate]);
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous errors
    
    try {
      console.log('Sending login request...');
      
      // Call backend API
      const response = await axios.post('https://site2.akms.org.in/api/login', {
        username: username,
        password: password
      });
      
      console.log('Login response:', response.data);
      
      // Check if login successful
      if (response.data.success) {
        console.log('Login successful, setting session storage');
        
        // Save admin status
        sessionStorage.setItem('isAdmin', 'true');
        sessionStorage.setItem('adminUsername', response.data.username || 'admin');
        
        console.log('Redirecting to dashboard...');
        
        // Redirect to dashboard - using your existing route
        navigate('/admindashboard');
      } else {
        // Show error message
        setError(response.data.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      
      // Show appropriate error message
      if (error.response) {
        setError(error.response.data.message || 'Login failed. Please try again.');
      } else if (error.request) {
        setError('Cannot connect to server. Please check if the backend is running.');
      } else {
        setError('Login failed. Please try again.');
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Title */}
        <h1 className="login-title">Admin Login</h1>
        
        {/* Error Message */}
        {error && <div className="login-error">{error}</div>}
        
        {/* Login Form */}
        <form onSubmit={handleSubmit}>
          {/* Username Field */}
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </div>
          
          {/* Password Field */}
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          
          {/* Login Button */}
          <button type="submit" className="login-button">
            Login
          </button>
        </form>
        
        {/* Back Link */}
        <div className="back-link">
          <Link to="/">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;